import { render, staticRenderFns } from "./ProductSkus.vue?vue&type=template&id=7dbbdd6a&scoped=true&"
import script from "./ProductSkus.vue?vue&type=script&lang=js&"
export * from "./ProductSkus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbbdd6a",
  null
  
)

export default component.exports